// routes.js
import LoginComponent from './components/Login.vue';
import Home from './components/Home.vue';
//import PageOne from './components/Page1.vue';
import PageOne from './components/Page1-ref.vue';
import PageTwo from './components/Page2.vue';
import Lesmateriaal from './components/Lesmateriaal.vue';
//import PageKlass from './components/PageKlass.vue';
import PageKlass from './components/PageKlass-validation.vue';
import PageKlassDefault from './components/PageKlassDefault.vue';
import LesMatKlass from './components/LesMatKlass.vue';
import Praktisch from './components/Praktisch.vue';
import Theoretisch from './components/Theoretisch.vue';

export const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginComponent
  },
  {
    path: '/home',
    component: Home,
    props: true,
    children: [
      { path: '', component: PageOne, name: 'page1' },
      {
        path: '/tijdslijn',
        component: PageTwo,
        props: true,
        children: [
          { path: '/', name: 'pageklassdefault', component: PageKlassDefault },
          { path: ':id', component: PageKlass, name: 'pageklass', props: true }
        ]
      },
      {
        path: '/lesmateriaal',
        component: LesMatKlass,
        redirect: '/lesmateriaal/praktisch',
        children: [
          {
            path: 'praktisch',
            component: Praktisch,
            name: 'praktisch',
            props: true
          },
          {
            path: 'theoretisch',
            component: Theoretisch,
            name: 'theoretisch',
            props: true
          }
        ]
      },
      { path: '*', redirect: { name: 'page1' } }
    ]
  },
  { path: '*', redirect: { name: 'page1' } }
];